export enum TypeOfMortgage {
  FHA = "FHA",
  VA = "VA",
  USDA = "USDA",
  CONVENTIONAL = "CONVENTIONAL",
}
